<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0)">
      <path d="M16 0.695312H0V3.82575H16V0.695312Z" :fill="fill" />
      <path d="M4.52175 4.86963H0V7.65222H4.52175V4.86963Z" :fill="fill" />
      <path d="M4.52175 12.522H0V15.3046H4.52175V12.522Z" :fill="fill" />
      <path d="M4.52175 8.6958H0V11.4784H4.52175V8.6958Z" :fill="fill" />
      <path
        d="M10.4347 4.86963H5.56519V7.65222H10.4347V4.86963Z"
        :fill="fill"
      />
      <path d="M10.4347 12.522H5.56519V15.3046H10.4347V12.522Z" :fill="fill" />
      <path d="M10.4347 8.6958H5.56519V11.4784H10.4347V8.6958Z" :fill="fill" />
      <path d="M16 4.86963H11.4783V7.65222H16V4.86963Z" :fill="fill" />
      <path d="M16 12.522H11.4783V15.3046H16V12.522Z" :fill="fill" />
      <path d="M16 8.6958H11.4783V11.4784H16V8.6958Z" :fill="fill" />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  props: {
    fill: {
      type: String,
      required: false,
      default: "#383F51",
    },
  },
};
</script>

<style></style>
